export default __webpack_public_path__ + "static/media/xgray_Icon.8eaa3c2d.svg";